/**
 * Vuex
 *
 * @library
 *
 * https://vuex.vuejs.org/en/
 */

// Lib imports
import Vue from "vue"
import Vuex from "vuex"

// Store functionality
import modules from "./modules"

import createPersistedState from "vuex-persistedstate"
import SecureLS from "secure-ls"
let ls = new SecureLS({ isCompression: false })

Vue.use(Vuex)

// Create a new store
const store = new Vuex.Store({
  plugins: [
    createPersistedState({
      key: "hmd_ri3_app",
      paths: ["app.company", "app.isThemeDark", "app.locale", "app.project", "app.user"],
      storage: {
        getItem: key => {
          try {
            return ls.get(key)
          } catch (error) {
            console.log(error)
            return null
          }
        },
        setItem: (key, value) => {
          try {
            return ls.set(key, value)
          } catch (error) {
            console.log(error)
            return null
          }
        },
        removeItem: key => {
          try {
            return ls.remove(key)
          } catch (error) {
            console.log(error)
            return null
          }
        }
      }
    })
  ],
  modules
})

export default store
